import {action, computed, observable, makeObservable} from "mobx";

import {DEVICE_ORIENTATIONS, SCREEN_SIZES, SCREEN_RESOLUTION} from "../../core/consts";

import {BaseUtils} from "./base-utils";
import {throttle} from "../throttle/throttle";


export class ResolutionUtils extends BaseUtils {
  @observable _screenWidth;
  @observable _orientation;
  _orientationChangedCallback = null;
  _resizeCallback = null;
  @observable container = null;

  constructor(container = window.document.body) {
    super();

    makeObservable(this);

    this.onOrientationChange = this.onOrientationChange.bind(this);
    this.onResolutionChange = this.onResolutionChange.bind(this);

    this.applyContainer(container);

    this.onOrientationChange();
    this.onResolutionChange();
    window.ondeviceorientation = this.onOrientationChange;
  }

  @action applyContainer(container) {
    this.container = container;

    const throttleOnresize = throttle(() => {
      this.onResolutionChange();
    }, 150);

    const throttleOnOrientationChange = throttle(() => {
      this.onOrientationChange();
    }, 150);

    this.container.ondeviceorientation = throttleOnOrientationChange;
    this.container.onresize = throttleOnresize;
    this.container.onload = throttleOnresize;

    setTimeout(throttleOnresize(), 0);
  }

  @computed get screenWidth() {
    return this._screenWidth;
  }

  set screenWidth(value) {
    this._screenWidth = value;
  }

  @computed get orientation() {
    return this._orientation;
  }

  set orientation(value) {
    this._orientation = value;
  }

  isSmallView(screenSize = this.resolveScreenSize()) {
    const isSmallView = screenSize === SCREEN_SIZES.sm_min;

    return isSmallView;
  }


  isMediumView(screenSize = this.resolveScreenSize()) {
    const isMediumView = [SCREEN_SIZES.md_min].indexOf(screenSize) > -1;

    return isMediumView;
  }

  isLargeView(screenSize = this.resolveScreenSize()) {
    const isLargeView = [SCREEN_SIZES.sm_min, SCREEN_SIZES.sm_max, SCREEN_SIZES.md_min, SCREEN_SIZES.md_max].indexOf(screenSize) === -1;

    return isLargeView;
  }

  onResolutionChange() {
    this.screenWidth = this.container.offsetWidth;

    if (this._resizeCallback) {
      this._resizeCallback(this.screenWidth);
    }
  }

  resolveScreenSize(screenWidth = this.screenWidth) {
    const sizes = Object.keys(SCREEN_RESOLUTION);
    let currentSize = '';

    sizes.reverse().forEach((size, index) => {
      const width = SCREEN_RESOLUTION[size];

      if (screenWidth >= width && currentSize === '') {
        currentSize = size;
      }
    });

    return currentSize;
  }

  onOrientationChange() {
    if (window.matchMedia("(orientation: portrait)").matches) {
      this.orientation = DEVICE_ORIENTATIONS.portrait;
    }

    if (window.matchMedia("(orientation: landscape)").matches) {
      this.orientation = DEVICE_ORIENTATIONS.landscape;
    }
  }
}
